module.exports = __webpack_public_path__ + "static/img/empty-section-left.25141d82.svg";